import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  width: auto;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { useTheme } from '../utils/styling/styled-components';
import { Popover } from '../Popover';
import { Alignment } from '../Position';
var Content = styled.div(_templateObject(), function (props) {
  return props.color;
}, function (props) {
  return props.theme.borderRadius.small;
}, function (props) {
  return props.size === 'small' && "\n    padding: 6px 10px;\n    line-height: 12px;\n  ";
}, function (props) {
  return props.size === 'medium' && "\n    padding: 6px 10px;\n    line-height: 14px;\n  ";
}, function (props) {
  return props.size === 'large' && "\n    padding: 10px 12px;\n  ";
});
export var Hint = function Hint(props) {
  var _props$color, _props$alignment, _props$arrowSize, _props$gutter;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var size = props.size || 'medium';
  var color = (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : colors.slate;
  return /*#__PURE__*/React.createElement(Popover, {
    alignment: (_props$alignment = props.alignment) !== null && _props$alignment !== void 0 ? _props$alignment : Alignment.BottomCenter,
    arrowColor: color,
    arrowSize: (_props$arrowSize = props.arrowSize) !== null && _props$arrowSize !== void 0 ? _props$arrowSize : size === 'small' ? 5 : 10,
    className: props.className,
    gutter: (_props$gutter = props.gutter) !== null && _props$gutter !== void 0 ? _props$gutter : size === 'small' ? 15 : 20,
    offset: props.offset,
    onClick: props.onClick,
    onOutsideClick: props.onOutsideClick,
    visible: props.visible,
    zIndex: props.zIndex,
    content: /*#__PURE__*/React.createElement(Content, {
      color: color,
      size: size,
      className: "hint-content"
    }, props.title)
  }, props.children);
};